module.exports = __webpack_public_path__ + "static/media/7_everstone.eb608901.svg";